enum QuestionTypeRaw {
  TEXT = 'QNTT',
  LONG_TEXT = 'QNLT',
  CHECKBOX = 'QNCBT',
  SELECTION = 'QNST',
  URL = 'QNUT',
  DISPLAY_ONLY = 'QDOT',
}

export default QuestionTypeRaw;
